import { useMemo, useState } from "react";
import * as React from "react";

import EmailForm from "components/email-form";

import { Patient } from "../services/types/patients.type";

type EmailProviderProps = {
  children?: React.ReactNode;
};

const EmailContext = React.createContext<any>(null);

export function EmailProvider({ children }: EmailProviderProps) {
  const [openModal, setOpenModal] = useState(false);
  const [patient, setPatient] = useState<Patient | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [initialDocuments, setInitialDocuments] = useState<File[]>([]);
  const [initialEmailContent, setInitialEmailContent] = useState<string>("");
  const [initialSubject, setInitialSubject] = useState<string>("");
  const [noSignature, setNoSignature] = useState<boolean>(false);

  const handleOpen = ({
    patient: patientArg,
    emailContent,
    emailSubject,
    noSignature: noSignatureArg
  }: {
    patient?: Patient;
    emailContent?: string;
    emailSubject?: string;
    noSignature?: boolean;
  } = {}) => {
    setPatient(patientArg || null);
    setOpenModal(true);
    setInitialEmailContent(emailContent ?? "");
    setInitialSubject(emailSubject ?? "");
    setNoSignature(noSignatureArg ?? false);
  };

  const handleClose = () => {
    setOpenModal(false);
    setPatient(null);
    setInitialDocuments([]);
    setInitialEmailContent("");
    setInitialSubject("");
    setNoSignature(false);
  };

  const value = useMemo(() => {
    return {
      handleOpen,
      selectedFiles,
      setSelectedFiles,
      setInitialDocuments,
      initialDocuments,
      initialEmailContent,
    };
  }, [initialDocuments, initialEmailContent, selectedFiles]);
  return (
    <EmailContext.Provider value={value}>
      {children}
      <EmailForm
        isOpen={openModal}
        onClose={handleClose}
        patient={patient || undefined}
        selectedFiles={selectedFiles}
        initialDocuments={initialDocuments}
        initialEmailContent={initialEmailContent}
        initialSubject={initialSubject}
        noSignature={noSignature}
      />
    </EmailContext.Provider>
  );
}

export default function useEmail() {
  const emailContext = React.useContext(EmailContext);
  if (!emailContext) {
    throw new Error(`useEmail must be used within a EmailProvider`);
  }

  return emailContext;
}
